
export enum SelectionMode {
  Single,
  Multi
}
